import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import ExtensionIcon from '@mui/icons-material/Extension';
import DrawIcon from '@mui/icons-material/Draw';
import { motion } from 'framer-motion';

const differentiators = [
  {
    title: 'Load analysis & test certificates before delivery',
    body: 'Structured verification so your bays meet defined load cases before materials ship.',
    icon: <VerifiedIcon sx={{ fontSize: 40 }} />,
  },
  {
    title: 'Custom accessories',
    body: 'Guides, protectors, decking, and add-ons matched to your operation — not one-size-fits-all.',
    icon: <ExtensionIcon sx={{ fontSize: 40 }} />,
  },
  {
    title: 'Custom warehouse / factory layout on CAD',
    body: 'Layouts drafted to your footprint, aisles, and material flow — not generic grids.',
    icon: <DrawIcon sx={{ fontSize: 40 }} />,
  },
];

export default function CorporateCamps() {
  return (
    <Box
      id="differentiators"
      className="circuit-bg"
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: '#ffffff',
        color: '#1a1a1a',
        position: 'relative',
        overflow: 'hidden',
        borderTop: '1px solid rgba(0,0,0,0.05)',
      }}
    >
      <Box
        component={motion.div}
        animate={{
          scale: [1, 1.2, 1],
          rotate: [0, 5, -5, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        sx={{
          position: 'absolute',
          top: -100,
          left: -100,
          width: 400,
          height: 400,
          background: 'rgba(255,106,0,0.03)',
          borderRadius: '50%',
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1, px: { xs: 2, sm: 3 } }}>
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Typography variant="overline" sx={{ color: '#ff6a00', fontWeight: 900, letterSpacing: 3 }}>
            Why Divine
          </Typography>
          <Typography variant="h3" sx={{ fontWeight: 900, mb: 1, color: '#1a1a1a', fontSize: { xs: '1.65rem', sm: '2rem', md: '3rem' } }}>
            What sets us apart
          </Typography>
          <Typography variant="body1" sx={{ mb: 5, color: '#555', maxWidth: 640 }}>
            Differentiator — engineering-led delivery, not catalog-only picking.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {differentiators.map((item, index) => (
            <Grid item xs={12} md={4} key={item.title}>
              <Paper
                component={motion.div}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                elevation={0}
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 0,
                  bgcolor: '#fafafa',
                  border: '1px solid rgba(0,0,0,0.06)',
                  transition: 'border-color 0.25s ease, box-shadow 0.25s ease',
                  '&:hover': {
                    borderColor: 'rgba(255,106,0,0.45)',
                    boxShadow: '0 12px 32px rgba(0,0,0,0.06)',
                  },
                }}
              >
                <Box sx={{ color: '#ff6a00', mb: 2 }}>{item.icon}</Box>
                <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5, lineHeight: 1.3 }}>
                  {item.title}
                </Typography>
                <Typography sx={{ color: '#555', lineHeight: 1.75 }}>{item.body}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
